var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#43418E;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "24,50 8,58 8,14 24,6 40,14 56,6 56,50 40,58  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 40,
    y1: 14,
    x2: 40,
    y2: 58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 24,
    y1: 8,
    x2: 24,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14,
    y1: 42,
    x2: 14,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 18,
    y1: 38,
    x2: 18,
    y2: 38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30,
    y1: 32,
    x2: 30,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 34,
    y1: 28,
    x2: 34,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 46,
    y1: 22,
    x2: 46,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 50,
    y1: 26,
    x2: 50,
    y2: 26
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.218843698c955c67b065ccf788edc488.svg";
export { ForwardRef as ReactComponent };